<template>
  <el-dialog v-model="status" :title="title" width="480px" top="3vh" @close="closeOrder">
    <div class="todayorder">
      <div v-for="(item,key) in data" :key="key" style="width: 450px; box-sizing: border-box; overflow: hidden;">
        <div style="padding-top: 10px; font-size: 14px; color:#000000;">
          <div style="line-height: 1.5;">
            
            <!-- <span style="font-weight: bold;">订单号</span>：{{item.orderid}} -->

            <span style="font-weight: bold;">订单号</span>：
  <template v-for="(oid, idx) in item.orderid.split('、')" :key="oid">
    <span class="link-cell" @click="seeOrder(oid.trim())">{{ oid.trim() }}</span>
    <span v-if="idx < item.orderid.split('、').length - 1">、</span>
  </template>
            
            
            
            <span style="font-weight: bold; margin-left: 30px;">日期</span>：{{item.add_time}}
          
          
          </div>
          <table border="1" cellpadding="0" cellspacing="0" style="width: 435px; margin-top: 5px; border-collapse: collapse; box-sizing: border-box;">
            <tr>
              <td>订单号</td>
              <td>货品名称</td>
              <td align="center">数量</td>
              <td align="center">单价</td>
              <td align="center">金额</td>
            </tr>
            <tr v-for="(p,k) in item.goods" :key="k">
              <td @click="seeOrder(p.orderid)" class="link-cell">{{ p.orderid }}</td>
              <td>{{ p.goods_name }}</td>
              <td align="center">{{ p.buy_num }}{{p.unit=='元'?'':p.unit}}</td>
              <td align="center">{{ p.single_price}}</td>
              <td align="center">{{ p.min_tot }}</td>
            </tr>
          </table>
          <div style="line-height: 1.5;">合计：{{item.price_tot}}&nbsp;&nbsp;&nbsp;&nbsp;备注：{{item.remark}}</div>
        </div>
      </div>
    </div>
       <edit-order ref="eorder" @success="init"></edit-order>
  </el-dialog>
</template>

<script>
import EditOrder from "@/components/order/editOrder"

export default {
  name: 'ShowOrder',
  components:{EditOrder},
  data(){
    return {
      status:false,
      title:'',
      uid:'',
      uname:'',
      price_tot:0,
      data: []  
    }
  },
  methods:{
    reload(){
      this.init(this.uid);
    },
    init(uid){
      var _this=this;
      if(uid === undefined){
        uid = _this.uid;
      }
      this.RequestApi('today_order.html',{'uid':uid}).then(function (res){
        if(res.status==1){
          if(res.data.length>0){
            _this.title=res.data[0]['uname']+" 订单";
            _this.data = res.data;
            _this.status=true;
          }else{
            _this.TipSuccess('今日未下单');
          }
        }
      })
    },

    init3(item){
      var _this=this;
      _this.uid = item.id,
      _this.uname = item.uname,
      _this.price_tot = item.price_tot,
      this.RequestApi('today_order.html',{'uid':_this.uid}).then(function (res){
        if(res.status==1){
          if(res.data.length>0){
            _this.title=res.data[0]['uname']+" 订单";
            _this.data=res.data;
            _this.status=true;
          }else{
            _this.TipSuccess('今日未下单');
          }
        }
      })
    },
    closeOrder:function (){
      this.title='';
      this.status=false;
    },
    seeOrder(orderid){
      this.$refs.eorder.init2(this.uid,this.uname,orderid,this.price_tot);
    }
  }
}
</script>
<style scoped lang="less">
.todayorder{
  max-height: 780px;
  overflow-y: auto;
}

.link-cell {
  color: #409EFF;          /* Element 主色调 */
  text-decoration: underline;
  cursor: pointer;
}
.link-cell:hover {
  color: #66b1ff;          /* hover 高亮 */
}

</style>
